$(document).ready(function() {
    $(document).on('change', '.uploader input.file', function() {
        var input_group = $(this).closest('.input-group');
        input_group.find('.o-filename').html($(this).val().split('\\').pop(-1));
    });
});
